export enum ToggleFollowType {
  FOLLOW,
  UNFOLLOW
}
